import { HttpErrorResponse } from '@angular/common/http';
import { NavigationExtras, Params, Router } from '@angular/router';
import { throwError as observableThrowError, Observable } from 'rxjs/';

export const DEFAULT_NAVIGATION_EXTRAS: NavigationExtras = {
  preserveFragment: true,
  queryParamsHandling: 'merge',
  replaceUrl: true,
  skipLocationChange: true,
};

export function getErrorPageQueryParams(
  code: number | null = null,
  title: string | null = null,
  detail: string | null = null,
): Params {
  return { code, title, detail };
}

export function getErrorPageQueryParamsForHttpErrorResponse(
  error: HttpErrorResponse,
): Params {
  const { message, status, statusText } = error;
  return getErrorPageQueryParams(status, statusText, message);
}

export function getNavigationExtrasForHttpErrorResponse(
  error: HttpErrorResponse,
  defaults: NavigationExtras = DEFAULT_NAVIGATION_EXTRAS,
): NavigationExtras {
  const queryParams = getErrorPageQueryParamsForHttpErrorResponse(error);
  return { ...defaults, queryParams };
}

export function getNavigationExtrasForError(
  code: number | null = null,
  title: string | null = null,
  detail: string | null = null,
  defaults: NavigationExtras = DEFAULT_NAVIGATION_EXTRAS,
): NavigationExtras {
  const queryParams = getErrorPageQueryParams(code, title, detail);
  return { ...defaults, queryParams };
}

export function handleRenavigationError(router: Router) {
  return (error: any): Observable<any> => {
    if (error instanceof HttpErrorResponse) {
      router.navigate(
        ['error'],
        getNavigationExtrasForHttpErrorResponse(error),
      );
    }

    return observableThrowError(error);
  };
}
